import request from '@/utils/request';

export const CUSTOM_DOMAINS = 'CUSTOM_DOMAINS';
export const CUSTOM_DOMAIN = 'CUSTOM_DOMAIN';
export const CUSTOM_DOMAIN_CREATE = 'CUSTOM_DOMAIN_CREATE';
export const CUSTOM_DOMAIN_UPDATE = 'CUSTOM_DOMAIN_UPDATE';
export const CUSTOM_DOMAIN_DELETE = 'CUSTOM_DOMAIN_DELETE';
export const CUSTOM_DOMAIN_VERIFY = 'CUSTOM_DOMAIN_VERIFY';
export const CUSTOM_DOMAIN_DNS_INSTRUCTIONS = 'CUSTOM_DOMAIN_DNS_INSTRUCTIONS';

// Public, pre-auth lookup: the login page is served from the agency's own domain and needs
// that agency's logo, name and colors before anyone is signed in. Resolved from the request
// host by the API, so it takes no arguments.
export const fetchCustomDomainBranding = () => async () => {
  return await request({
    path: '/v1/custom_domains/branding'
  });
};

export const fetchCustomDomains =
  (businessUnitId = null) =>
  async dispatch => {
    const path = businessUnitId ? `/v1/custom_domains?business_unit_id=${businessUnitId}` : `/v1/custom_domains`;

    const response = await request({
      path
    });
    dispatch({
      payload: response,
      type: CUSTOM_DOMAINS
    });
    return response;
  };

export const fetchCustomDomain = id => async dispatch => {
  const response = await request({
    path: `/v1/custom_domains/${id}`
  });
  dispatch({
    payload: response,
    type: CUSTOM_DOMAIN
  });
  return response;
};

export const createCustomDomain = (businessUnitId, data) => async dispatch => {
  const response = await request({
    path: `/v1/custom_domains`,
    method: 'POST',
    body: {
      business_unit_id: businessUnitId,
      custom_domain: data
    }
  });
  dispatch({
    payload: response,
    type: CUSTOM_DOMAIN_CREATE
  });
  return response;
};

export const updateCustomDomain = (id, data) => async dispatch => {
  const response = await request({
    path: `/v1/custom_domains/${id}`,
    method: 'PATCH',
    body: { custom_domain: data }
  });
  dispatch({
    payload: response,
    type: CUSTOM_DOMAIN_UPDATE
  });
  return response;
};

export const deleteCustomDomain = id => async dispatch => {
  await request({
    path: `/v1/custom_domains/${id}`,
    method: 'DELETE'
  });
  dispatch({
    payload: { id },
    type: CUSTOM_DOMAIN_DELETE
  });
};

export const verifyCustomDomain = id => async dispatch => {
  const response = await request({
    path: `/v1/custom_domains/${id}/verify`,
    method: 'POST'
  });
  dispatch({
    payload: response,
    type: CUSTOM_DOMAIN_VERIFY
  });
  return response;
};

export const fetchDnsInstructions = id => async dispatch => {
  const response = await request({
    path: `/v1/custom_domains/${id}/dns_instructions`
  });
  dispatch({
    payload: response,
    type: CUSTOM_DOMAIN_DNS_INSTRUCTIONS
  });
  return response;
};
